/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { AssignActionStatusDetailsDtoModel, AssignActionStatusDetailsDtoModelType } from "./AssignActionStatusDetailsDtoModel"
import { AssignActionStatusDetailsDtoModelSelector } from "./AssignActionStatusDetailsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * AssignActionStatusDtoBase
 * auto generated base class for the model AssignActionStatusDtoModel.
 */
export const AssignActionStatusDtoModelBase = ModelBase
  .named('AssignActionStatusDto')
  .props({
    __typename: types.optional(types.literal("AssignActionStatusDto"), "AssignActionStatusDto"),
    id: types.identifier,
    originRouteId: types.union(types.undefined, types.null, types.integer),
    originRouteName: types.union(types.undefined, types.null, types.string),
    targetRouteId: types.union(types.undefined, types.null, types.integer),
    targetRouteName: types.union(types.undefined, types.null, types.string),
    visitId: types.union(types.undefined, types.null, types.integer),
    visitName: types.union(types.undefined, types.null, types.string),
    completed: types.union(types.undefined, types.boolean),
    moveStopTargetIndex: types.union(types.undefined, types.number),
    details: types.union(types.undefined, types.null, types.late((): any => AssignActionStatusDetailsDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AssignActionStatusDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get originRouteId() { return this.__attr(`originRouteId`) }
  get originRouteName() { return this.__attr(`originRouteName`) }
  get targetRouteId() { return this.__attr(`targetRouteId`) }
  get targetRouteName() { return this.__attr(`targetRouteName`) }
  get visitId() { return this.__attr(`visitId`) }
  get visitName() { return this.__attr(`visitName`) }
  get completed() { return this.__attr(`completed`) }
  get moveStopTargetIndex() { return this.__attr(`moveStopTargetIndex`) }
  details(builder: string | AssignActionStatusDetailsDtoModelSelector | ((selector: AssignActionStatusDetailsDtoModelSelector) => AssignActionStatusDetailsDtoModelSelector) | undefined) { return this.__child(`details`, AssignActionStatusDetailsDtoModelSelector, builder) }
}
export function selectFromAssignActionStatusDto() {
  return new AssignActionStatusDtoModelSelector()
}

export const assignActionStatusDtoModelPrimitives = selectFromAssignActionStatusDto().originRouteId.originRouteName.targetRouteId.targetRouteName.visitId.visitName.completed.moveStopTargetIndex
